import gql from 'graphql-tag';

const ADD_NOTE_WORKITEM = gql`
  mutation($input: CreateNoteInput!) {
    createNote(input: $input) {
      noteId
      addedOn
      content
      addedBy {
        userId
        firstName
        lastName
        email
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
      workItem {
        workId
        module
      }
      privacyType
    }
  }
`;

const DELETE_NOTE_WORKITEM = gql`
  mutation($input: NoteIdentifierInput!) {
    deleteNote(input: $input)
  }
`;

const UPDATE_NOTE_WORKITEM = gql`
  mutation($input: UpdateNoteInput!) {
    updateNote(input: $input) {
      noteId
      addedBy {
        userId
        firstName
        lastName
        email
      }
      addedOn
      content
      attachments {
        fileName
        originalFileName
        fileSize
      }
      workItem {
        workId
        module
      }
      privacyType
    }
  }
`;

export { ADD_NOTE_WORKITEM, DELETE_NOTE_WORKITEM, UPDATE_NOTE_WORKITEM };
